import type { Article } from '../types/content'

export const articles: Article[] = [
  {
    slug: 'the-quiet-decade',
    title: 'The quiet decade: why Africa’s next great companies won’t look like the last ones',
    category: 'Africa',
    date: 'June 2026',
    readTime: '9 min',
    excerpt:
      'The headline era is over. What comes next is slower, more infrastructural, and far more valuable.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2359222f-1ab9-4f1c-8f01-201aab6bf660.jpg',
    featured: true,
  },
  {
    slug: 'raising-without-a-track-record',
    title: 'Raising without a track record',
    category: 'Fundraising',
    date: 'May 2026',
    readTime: '7 min',
    excerpt:
      'Evidence beats narrative. A working method for first-time founders and first-time managers.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/eb231a24-b644-4174-a7d1-2724f43729c2.jpg',
  },
  {
    slug: 'the-founder-you-become',
    title: 'The founder you become at Series A',
    category: 'Leadership',
    date: 'April 2026',
    readTime: '6 min',
    excerpt:
      'The company you built is not the company you must now run. On letting go of the work that made you.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7df3923c-ed6c-4898-9b84-1ad9fac2a0ff.jpg',
  },
  {
    slug: 'ecosystems-are-not-events',
    title: 'Ecosystems are not events',
    category: 'Startups',
    date: 'March 2026',
    readTime: '5 min',
    excerpt:
      'Demo days do not make a market. What actually compounds is boring, structural and unglamorous.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8dcb3393-e15e-45df-8135-22b35efcd92e.jpg',
  },
  {
    slug: 'models-in-our-own-languages',
    title: 'Models in our own languages',
    category: 'Technology',
    date: 'February 2026',
    readTime: '8 min',
    excerpt:
      'Why linguistic infrastructure is the most underpriced opportunity on the continent.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b769c5e4-db72-47aa-8054-9ece4f7d111b.jpg',
  },
  {
    slug: 'patient-capital-is-a-product',
    title: 'Patient capital is a product',
    category: 'Investment',
    date: 'January 2026',
    readTime: '6 min',
    excerpt:
      'Blended finance fails when it is designed for institutions instead of founders.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/0409fb59-c170-43c3-a4c1-3d690b21d906.jpg',
  },
  {
    slug: 'innovation-without-theatre',
    title: 'Innovation without theatre',
    category: 'Innovation',
    date: 'December 2025',
    readTime: '7 min',
    excerpt:
      'Forty pilots and no products. How large organisations mistake motion for progress.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7fa7ff0a-1a18-4c7e-b241-17c6577c3e24.jpg',
  },
]

export const insightCategories = [
  'All',
  'Startups',
  'Innovation',
  'Leadership',
  'Fundraising',
  'Africa',
  'Technology',
  'Investment',
]
